module.exports = __webpack_public_path__ + "static/img/ThailandPost_Logo.c21ab7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/ThailandPost_Logo.png
// module id = S4N+
// module chunks = 134